import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Col, Row } from 'reactstrap'
import CustomSelect from '../../../common/CustomReactSelectComponent'
import { BRANCH_MANAGER, MANAGER } from '../../../constants/permissions'
import { notificationDanger } from '../../../utils/customToastify'
import { getUsersForDropDown } from '../../Users/redux/userActions'
import { assignUser } from '../redux/ContactActions'
import { TRUCK_SALES } from '../../../constants/divisions'

const SelectUserToAssigne = ({ selectedRows, loadData, toggleModal, isMasterData }) => {
  const dispatch = useDispatch()
  const { division_id: divisionId, permissions, userId } = useSelector((state) => state.auth.user)
  const userOptions = useSelector((state) => state.users.usersForDropDown)
  const [isDisabled, setIsDisabled] = useState(false)

  const [user, setUser] = useState(null)

  const onChange = (value) => {
    setUser(value ? value.id : null)
  }

  useEffect(() => {
    dispatch(getUsersForDropDown({}, divisionId))
    if (!permissions.includes(MANAGER) && !permissions.includes(BRANCH_MANAGER)) {
      setIsDisabled(true)
      setUser(userId)
    }
  }, [])

  const handleUserAssign = async () => {
    if (!user) {
      notificationDanger('Please select User')
      return
    }

    dispatch(assignUser(user, selectedRows, isMasterData))
    loadData()
    toggleModal('isUserModalToggle')
  }

  return (
    <>
      <Row>
        <Col>
          <CustomSelect
            options={Array.isArray(userOptions) ? userOptions : []}
            onChange={onChange}
            defaultValue={user}
            label='Select User'
            placeholder='Please Select...'
            disabled={isDisabled}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col className='d-flex justify-content-end'>
          <Button
            className='btn btn-gold btn-sm mr-2'
            onClick={handleUserAssign}
            disabled={divisionId === TRUCK_SALES ? !user : isDisabled || !user}
          >
            Assign
          </Button>
          <Button className='btn btn-sm' color='danger' onClick={() => toggleModal('isUserModalToggle')}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default SelectUserToAssigne
